import { SpinningLoader } from "risa-oasis-ui_v2";

const InlineLoader = () => {
  return (
    <div className="inline-loader-container flex h-full w-full items-center justify-center">
      <SpinningLoader />
      <div className="inline-loader-message text-body text-primaryGray-7">
        Loading portals details...
      </div>
    </div>
  );
};

export default InlineLoader;
